import React from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink, Button } from 'reactstrap'
import { ACTIONS } from '@/store/Documentation'
import { TreeView } from '@/components/TreeView'
import Icon from '@/components/Icon'
import { prepareTreeData, processTreeData, TREE_TYPES } from './dataSource'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ITEM_TYPES } from '@/constants'

class DocumentationContent extends React.Component {
  constructor (props, context) {
    super(props, context)

    const actions = {}
    for (const key in ACTIONS) {
      const actionName = ACTIONS[key]
      actions[actionName] = props[actionName]
    }
    const { tree } = props.documentation
    const { internal, external } = prepareTreeData(tree, actions, props.localize, props.locale)
    this.state = {
      internal,
      external
    }
  }
  tabCss (tab) {
    return (this.props.activeTab === tab ? 'active' : '')
  }
  handleNewItemCreated (type, item) {
    this.props.create({ type, ...item })
  }
  handleChange (treeType, treeData) {
    const newState = { ...this.state }
    newState[treeType] = treeData
    this.setState(newState)
    this.props.change({ treeType, tree: processTreeData(treeData) })
  }
  canDrop ({ nextParent }) {
    if (nextParent === null) { return true }
    return nextParent.title.props.type === 'chapter'
  }
  renderTab ({ treeType, localize, rowDirection, treeData }) {
    const isLoading = (this.props.documentation.updating === true)
    return (
      <TabPane tabId={treeType}>
        <Button
          color='primary'
          onClick={() => this.props.edit({ localize, item: { itemType: ITEM_TYPES.CHAPTER, treeType, file: null } })}><Icon name='plus' /><span>{localize('Documentation.AddChapterOrDocument')}</span></Button>
        {isLoading && <div className='white-box' style={{ marginTop: 20 }}><LoadingIndicator /></div>}
        <hr className='mt-5' />
        {!isLoading && <TreeView
          rowDirection={rowDirection}
          treeData={treeData}
          canDrop={x => this.canDrop(x)}
          onChange={data => this.handleChange(treeType, data)}
        />}
      </TabPane>
    )
  }
  render () {
    const { localize, rtl } = this.props
    const rowDirection = !rtl ? 'ltr' : 'rtl'
    return (
      <React.Fragment>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={this.tabCss(TREE_TYPES.INTERNAL)}
              onClick={() => { this.props.onActiveTabChange(TREE_TYPES.INTERNAL) }} >
              {localize('Documentation.InternalWeb')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.tabCss(TREE_TYPES.EXTERNAL)}
              onClick={() => { this.props.onActiveTabChange(TREE_TYPES.EXTERNAL) }} >
              {localize('Documentation.ExternalWeb')}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.props.activeTab}>
          {this.renderTab({ treeType: TREE_TYPES.INTERNAL, localize, rowDirection, treeData: this.state.internal })}
          {this.renderTab({ treeType: TREE_TYPES.EXTERNAL, localize, rowDirection, treeData: this.state.external })}
        </TabContent>
      </React.Fragment>
    )
  }
}

export default DocumentationContent



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/documentation/content.js